import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

/**
 * Contesto pagina corrente esposto ai plugin TOP_BAR / BOTTOM_BAR.
 *
 * La view aggiorna lo store con i dati che vuole rendere disponibili
 * ai pulsanti custom (filtri attivi, selezioni, totali, ecc.).
 * Viene azzerato automaticamente ad ogni cambio di route.
 */
export const usePluginContextStore = defineStore('pluginContext', () => {
  const contesto = ref<Record<string, unknown>>({})
  const entitaId = ref<number | null>(null)
  const entitaTipo = ref<string>('')

  function set(ctx: Record<string, unknown>, opts?: { entitaId?: number | null; entitaTipo?: string }) {
    contesto.value = ctx
    if (opts?.entitaId !== undefined) entitaId.value = opts.entitaId ?? null
    if (opts?.entitaTipo !== undefined) entitaTipo.value = opts.entitaTipo
  }

  function reset() {
    contesto.value = {}
    entitaId.value = null
    entitaTipo.value = ''
  }

  return { contesto, entitaId, entitaTipo, set, reset }
})

/**
 * Composable da usare nelle view per esporre il contesto ai plugin.
 * Azzera automaticamente lo store quando la view viene smontata.
 *
 * Esempio:
 *   const { setPluginContext } = usePluginPageContext()
 *   watch(filtri, () => setPluginContext({ filtro: filtri.value, totale: lista.value.length }))
 */
export function usePluginPageContext() {
  const store = usePluginContextStore()
  const route = useRoute()

  // Azzera il contesto quando cambia la route (navigazione via verso un'altra pagina)
  watch(() => route.path, () => store.reset())

  function setPluginContext(
    ctx: Record<string, unknown>,
    opts?: { entitaId?: number | null; entitaTipo?: string },
  ) {
    store.set(ctx, opts)
  }

  return { setPluginContext }
}
